import Vue from 'vue';
import Components from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Components({
  components: {},
})

export default class LogList extends Vue {
  @Prop()
  public data: any;
  public tableTitle: any[] = [
    {
      text: '合约',
      width: '2rem',
      name: 'targetId',
    },
    {
      text: '合约ID',
      width: '6rem',
      name: 'ID',
    },
    {
      text: '操作类型',
      width: '3rem',
      name: 'optionType',
    },
    {
      text: '运行状态',
      width: '2rem',
      name: 'runState',
    },
    {
      text: '机器Mac地址',
      width: '3rem',
      name: 'computedMac',
    },
    {
      text: '操作时间',
      width: '4rem',
      name: 'optionTime',
    },
    {
      text: '描述',
      width: '9rem',
      name: 'describe',
    }];
  // public tableData: any[] = [
  //   {
  //     ID: '11111111111111111111111111111111111',
  //     optionType: '1111',
  //     runState: '11111',
  //     computedMac: '88888',
  //     optionTime: '2018-02-12 12:12:12',
  //     describe: '22222222',
  //   },
  // ];

  // 返回
  public handleGoBack() {
    this.$emit('goBack');
  }

  public activated() {
    // 语言初始化
    // this.tableTitle[0].text = this.$store.state.language.v12k113;
    // this.tableTitle[1].text = this.$store.state.language.v12k114;
    // this.tableTitle[2].text = this.$store.state.language.v12k115;
    // this.tableTitle[3].text = this.$store.state.language.v12k116;
    // this.tableTitle[4].text = this.$store.state.language.v12k132;
    // this.tableTitle[5].text = this.$store.state.language.v12k117;
    // this.tableTitle[6].text = this.$store.state.language.v12k132;
  }
}



// WEBPACK FOOTER //
// ./src/views/TradeDetail/components/CheckFullStop/LogList/LogList.ts